export const TinaEvents = {};

TinaEvents.hasActiveEvent = () => {
  return TinaEvents.isFirstEvent() ||
    TinaEvents.isPeekIntoPast() ||
    TinaEvents.lightHeartedJoy()
}

TinaEvents.displayHint = () => {
  return TinaEvents.isPeekIntoPast() ||
    TinaEvents.lightHeartedJoy()
}

TinaEvents.isFirstEvent = () => {
  // czy był dziś event
  if(EventStateService.tinaDailyEventChecked) {
    return false;
  }

  // czy już drugi rozdział
  if(!EventStateService.secondChapterIntro) {
    return false;
  }

   // Czy MC pracował już 3 razy
   if(Yosemite.EventStateManager.timesWorkedMarketing < 3) {
    return false;
  }

  // Czy jest rano
  if(YsControllers.TimeController.getCurrentDayTime() !== YsControllers.TimeController.DayTimeEnum.MORNING) {
    return false;
  }

  // czy była pierwsza rozmowa z Dianą
  if(!EventStateService.dianaFirstEvent) {
    return false;
  }

  return !EventStateService.tinaFirstEvent;
}

TinaEvents.isPeekIntoPast = () => {
  // czy był dziś event
  if(EventStateService.tinaDailyEventChecked) {
    return false;
  }

  // Czy jest rano
  if(YsControllers.TimeController.getCurrentDayTime() !== YsControllers.TimeController.DayTimeEnum.MORNING) {
    return false;
  }

  // czy był poprzedni
  if(!EventStateService.tinaFirstEvent) {
    return false;
  }

  return !EventStateService.tinaPeekIntoPast;
}

TinaEvents.lightHeartedJoy = () => {
   // Czy jest rano
   if(YsControllers.TimeController.getCurrentDayTime() !== YsControllers.TimeController.DayTimeEnum.MORNING) {
    return false;
  }

  if(EventStateService.tinaDailyEventChecked) {
    return false;
  }

  // czy był tinaPeekIntoPast event
  if(!EventStateService.tinaPeekIntoPast) {
    return false;
  }

  return !EventStateService.tinaLightHeartedJoy;
}

TinaEvents.revelation = () => {
  if(EventStateService.tinaDailyEventChecked) {
    return false;
  }

  if(EventStateService.tinaLightHeartedJoy) {
    return false;
  }

  return !EventStateService.tinaRevelation;
}
